import { useEffect, useRef } from 'react';
import { Grid, Container, Card, CardContent, Box, Typography } from '@mui/material';
import HubspotForm from 'react-hubspot-form';
import { withAuth } from '../../../components/HOC/withAuth';

function ContactUs() {
  const formRef = useRef(null);

  useEffect(() => {
    // Suppress ResizeObserver errors that commonly occur with HubSpot forms
    const originalError = console.error;
    console.error = (...args) => {
      if (args[0]?.includes?.('ResizeObserver loop completed with undelivered notifications')) {
        return;
      }
      originalError.apply(console, args);
    };

    // Cleanup function to restore original console.error and handle form cleanup
    return () => {
      console.error = originalError;

      // Additional cleanup for any remaining observers
      if (formRef.current) {
        const observers = formRef.current.querySelectorAll('*');
        observers.forEach((element) => {
          if (element._resizeObserver) {
            element._resizeObserver.disconnect();
          }
        });
      }
    };
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 'bold',
            color: '#1f2937',
            mb: 2,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
          }}
        >
          Contact Us
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: '#6b7280',
            fontWeight: 400,
          }}
        >
          Contact us below and one of our team members will be with you shortly
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card
            ref={formRef}
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <HubspotForm
                portalId="22711473"
                formId="ca14132c-0097-475b-9219-72a856b45537"
                onSubmit={() => console.log('Form submitted successfully!')}
                onReady={() => console.log('HubSpot form is ready')}
                loading={
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '200px',
                    }}
                  >
                    <Typography variant="body1" sx={{ color: '#6b7280' }}>
                      Loading contact form...
                    </Typography>
                  </Box>
                }
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withAuth(ContactUs);
